import { twMerge } from "tailwind-merge";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search.svg";

export default function SearchView({ value, onChange, className }: { value: string, onChange: (e: React.ChangeEvent<HTMLInputElement>) => void, className?: string }) {
    return (
        <div className={twMerge("flex items-center gap-2 bg-white rounded-md px-2.5 py-3.5", className)}>
            <SearchIcon className="w-5 h-5 [&_path]:stroke-[#A9A9A9]" />
            <input type="text" placeholder="Search" className="w-full h-full outline-none" value={value} onChange={onChange} />
        </div>
    )
}